import React from 'react'
import Chip from '../components/Chip'

const IndexPage = ({ data }) => (
  <div className="container">
    <ul>
      {data.allContentfulPage.edges.map(edge => (
        <li key={edge.node.slug}>
          <Chip
            to={edge.node.slug}
            title={edge.node.title}
            imageUrl={edge.node.image.file.url}
            description={edge.node.description.description}
          />
        </li>
      ))}
    </ul>
  </div>
)

export default IndexPage

export const indexQuery = graphql`
  query indexQuery {
    allContentfulPage(
      filter: { node_locale: { eq: "en-US" } }
      sort: { fields: [stackPosition] }
    ) {
      edges {
        node {
          title
          slug
          image {
            file {
              url
            }
          }
          description {
            description
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js